
import { Ref, defineComponent, onMounted, ref } from 'vue'
import SearchBar from '@/retail/contexts/customers/components/SearchBar.vue'
import CustomerList from '@/retail/contexts/customers/components/CustomerList.vue'
import { IdfButton, IdfLoader } from '@invivodf/ui-kit'
import { useClient } from '../../composables/useClient'
import { User } from '../../services/user.service'

export default defineComponent({
  name: 'VCustomers',
  components: { SearchBar, CustomerList, IdfLoader, IdfButton },
  setup() {
    const CUSTOMERS_PER_PAGE = 50
    const searchFieldUsed = ref(false)
    const allCustomers: Ref<User[]> = ref([])
    const displayedCustomers: Ref<User[]> = ref([])
    const { searchUsers } = useClient()
    const isLoading = ref(false)
    const initialQuery = ref('')

    const addSearchQueryToUrl = (query: string) => {
      const url = new URL(window.location.href)
      url.searchParams.set('search', query)
      url.searchParams.set('page', '1')
      window.history.pushState({}, '', url.toString())
    }

    const addPageToUrl = (page: number) => {
      const url = new URL(window.location.href)
      url.searchParams.set('page', page.toString())
      window.history.pushState({}, '', url.toString())
    }

    const searchCustomers = (query: string, page = 1) => {
      if (query.length < 2) return
      isLoading.value = true
      searchFieldUsed.value = true
      if (query !== initialQuery.value) {
        addSearchQueryToUrl(query)
      }

      searchUsers(query)
        .then(async (result) => {
          allCustomers.value = result
          displayedCustomers.value = result.slice(0, CUSTOMERS_PER_PAGE * page)
          isLoading.value = false
        })
        .catch(() => {
          isLoading.value = false
        })
    }

    const loadMoreResults = () => {
      const currentLength = displayedCustomers.value.length
      const newLength = currentLength + CUSTOMERS_PER_PAGE
      displayedCustomers.value = allCustomers.value.slice(0, newLength)
      addPageToUrl(Math.ceil(newLength / CUSTOMERS_PER_PAGE))
    }

    onMounted(() => {
      const url = new URL(window.location.href)
      const searchQuery = url.searchParams.get('search')
      const page = url.searchParams.get('page')
      if (searchQuery) {
        initialQuery.value = searchQuery
        searchCustomers(searchQuery, page ? parseInt(page, 10) : 1)
      }
    })

    return {
      searchCustomers,
      loadMoreResults,
      allCustomers,
      displayedCustomers,
      searchFieldUsed,
      isLoading,
      initialQuery,
      CUSTOMERS_PER_PAGE,
    }
  },
})
